const ICONS = {
  X:
    'M6.804 5.5l3.928-3.93A.92.92 0 109.431.268L5.5 4.198 1.574.268A.92.92 0 10.271 1.57L4.2 5.5.271 9.43a.92.92 0 101.302 1.3L5.5 6.8l3.93 3.93a.92.92 0 101.301-1.302L6.804 5.5z',
  CARET_DOWN:
    'M10.796 2.61a.66.66 0 00-.484-.204H.688a.66.66 0 00-.484.204.661.661 0 00-.204.484.66.66 0 00.204.483L5.017 8.39a.661.661 0 00.483.204.66.66 0 00.483-.204l4.813-4.813A.661.661 0 0011 3.094a.662.662 0 00-.204-.484z',
};

const SIZES = {
  XXS: '11',
  XS: '15',
  S: '22',
  M: '30',
  L: '44',
  XL: '60',
  XXL: '90',
};

export { ICONS, SIZES };
